import { j as n } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as m, useState as u, useEffect as f } from "react";
import { R as s } from "./RawLoader-7qDMD85G.mjs";
const a = (r) => {
  const [e, t] = u(r === 0);
  return f(() => {
    if (r === 0)
      return;
    const o = setTimeout(() => t(!0), r);
    return () => {
      clearTimeout(o);
    };
  }, [r]), [e];
}, p = m(({ delay: r = 200, ...e }, t) => {
  const [o] = a(r);
  return o ? /* @__PURE__ */ n.jsx(s, { ref: t, ...e }) : null;
});
p.displayName = "Loader";
export {
  p as L
};
